<div class="preview-container">
  <ng-content></ng-content>
</div>